import React from 'react';
import {
  Box,
  Button,
  Typography,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { DEFAULT_AUDIT_LOG_PERIODS } from '@utils/time/types';
import { TimePeriodSelectorProps } from './types';
import FormattedAlias from '../Translations/FormattedAlias';
import {
  containerBox,
  captionText,
  getToggleButtonGroupStyles,
} from './styles';

const TimePeriodSelector: React.FC<TimePeriodSelectorProps> = React.memo(
  ({
    selectedPeriod,
    onPeriodChange,
    periods = DEFAULT_AUDIT_LOG_PERIODS,
    showCustomRange = false,
    onCustomRangeClick,
    label = 'Select Time Period',
    size = 'small',
    disabled = false,
  }) => {
    const handlePeriodChange = (
      _: React.MouseEvent<HTMLElement>,
      value: string | null,
    ): void => {
      if (value !== null && value !== 'custom') {
        onPeriodChange(value as typeof selectedPeriod);
      }
    };

    return (
      <Box sx={containerBox}>
        <Typography variant='caption' sx={captionText}>
          <FormattedAlias id={label} />
        </Typography>
        <Stack direction='row' spacing={1}>
          <ToggleButtonGroup
            value={selectedPeriod === 'custom' ? null : selectedPeriod}
            exclusive
            onChange={handlePeriodChange}
            size={size}
            color='primary'
            disabled={disabled}
            sx={getToggleButtonGroupStyles()}
          >
            {periods.map((period) => (
              <ToggleButton key={period.value} value={period.value}>
                <FormattedAlias id={period.label} />
              </ToggleButton>
            ))}
          </ToggleButtonGroup>

          {showCustomRange && onCustomRangeClick && (
            <Button
              variant='outlined'
              color='primary'
              size={size}
              startIcon={<DateRangeIcon />}
              onClick={onCustomRangeClick}
              disabled={disabled}
            >
              <FormattedAlias id={'Custom Range'} />
            </Button>
          )}
        </Stack>
      </Box>
    );
  },
);

TimePeriodSelector.displayName = 'TimePeriodSelector';

export default TimePeriodSelector;
